import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { IconPackage } from '@redteclab/icons'

import { Button, Divider } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config'
import { urlResolverGetOrderQuestion } from '../../../url-handling'

import { ContactPageCommonCtas } from './ContactPageCommonCtas'
import { ContactPageLastOrder } from './ContactPageLastOrder'
import { useContactPageLastOrderContext } from './ContactPageLastOrderContext'
import { ContactPageLastOrderShortcutsCtaList } from './ContactPageLastOrderShortcutsCtaList'

export const ContactPageCtaListLoggedIn: FC = () => {
  const globalConfig = useGlobalConfigContext()
  const { lastOrder, totalItems } = useContactPageLastOrderContext()
  const intl = useIntl()

  return (
    <div className="mt-6 grid grid-cols-1 gap-3 tablet:mt-0">
      <div className="flex flex-col items-start rounded-m bg-light-primary-medium px-4 py-6">
        <Button
          className="justify-start"
          size="large"
          startIcon={<IconPackage color="black" />}
          variant="text"
        >
          {lastOrder?.orderMasterData?.orderDate ? (
            <FormattedMessage
              id="contact.ordersSection.card.title"
              values={{
                date: intl.formatDate(lastOrder.orderMasterData.orderDate),
              }}
            />
          ) : (
            <FormattedMessage id="account.orders.title" />
          )}
        </Button>

        <div className="my-6 grid w-full grid-cols-1 gap-6 tablet:grid-cols-3">
          <div className="col-span-1">
            <ContactPageLastOrder />
          </div>
          <div className="tablet:col-span-2">
            <ContactPageLastOrderShortcutsCtaList />
          </div>
        </div>

        {totalItems && totalItems > 1 ? (
          <>
            <Button<'a'>
              className="hidden tablet:flex"
              color="secondary"
              href={urlResolverGetOrderQuestion(globalConfig)}
              size="small"
            >
              <FormattedMessage id="account.lastOrder.allOrders.label" />
            </Button>
            <div className="w-full tablet:hidden">
              <Divider />
              <Button<'a'>
                className="mt-6 w-full"
                color="secondary"
                data-qa-id="qa-id-contact-page-all-orders-button"
                href={urlResolverGetOrderQuestion(globalConfig)}
              >
                <FormattedMessage id="account.lastOrder.allOrders.label" />
              </Button>
            </div>
          </>
        ) : null}
      </div>
      <div className="grid grid-cols-1 gap-3 tablet:grid-cols-2">
        <ContactPageCommonCtas isUserLoggedIn />
      </div>
    </div>
  )
}
